import ApiService from "@/services";
import { handleApiError } from "../helpers";

const state = {
  settings: {},
  properties: [],
  fetching: false,
  propertyData: null,
  fetchingFacilities: false,
  fetchingAvailability: false,
  availabiltyDefaultMedia: [],
  documents: {},
};

const getters = {};

const mutations = {
  setProperties(state, data) {
    state.properties = data;
    state.fetching = false;
  },
  setProperty(state, data) {
    state.propertyData = data;
    state.fetching = false;
  },
  setFetching(state, data) {
    state.fetching = data;
  },
  setFetchingAvailability(state, data) {
    state.fetchingAvailability = data;
  },
  setFetchingFacilities(state, data) {
    state.fetchingFacilities = data;
  },
  setAvailabiltyDefaultMedia(state, data) {
    state.availabiltyDefaultMedia = data;
  },
  setSettingsData(state, data) {
    state.settings = data;
  },
  setDocumentsData(state, data) {
    state.documents = data;
  },
};

const actions = {
  async searchProperties({ commit }, params) {
    try {
      commit("setFetching", true);
      const response = await ApiService.get(`properties/search`, { params });
      commit("setProperties", response.data.data);
      return response?.data?.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async countProperties() {
    try {
      return await ApiService.get("properties/count");
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async findEhotelAvailability({ commit }, payload) {
    const load = payload.cache || payload._load;
    try {
      if (load) {
        commit("setFetchingAvailability", true);
      }
      const data = await ApiService.get("properties/ehotel/availability", {
        params: payload,
      });
      return data;
    } catch (error) {
      throw handleApiError(error);
    } finally {
      if (load) {
        commit("setFetchingAvailability", false);
      }
    }
  },
  async findNuiteeAvailability({ commit }, payload) {
    try {
      if (payload._load) {
        commit("setFetchingAvailability", true);
      }
      const data = await ApiService.get("properties/nuitee/availability", {
        params: payload,
      });
      return data;
    } catch (error) {
      throw handleApiError(error);
    } finally {
      if (payload._load) {
        commit("setFetchingAvailability", false);
      }
    }
  },
  async findCultswitchAvailability({ commit }, payload) {
    try {
      commit("setFetchingAvailability", true);
      const data = await ApiService.get("properties/cultswitch/availability", {
        params: payload,
      });
      return data;
    } catch (error) {
      throw handleApiError(error);
    } finally {
      commit("setFetchingAvailability", false);
    }
  },
  async getPropertyById({ commit }, id) {
    try {
      commit("setFetching", true);
      const response = await ApiService.get(`properties/${id}`);
      commit("setProperty", response.data.data);
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async getPropertyCalendarData(_, params) {
    try {
      const { data } = await ApiService.get(`properties/calendar-data`, {
        params,
      });
      return data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async getAllFacilities() {
    try {
      const { data } = await ApiService.get("properties/facilities");
      return data.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async getPropertyTypes() {
    try {
      const { data } = await ApiService.get("properties/types");
      return data.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async fetchPropertyMedia(_, { propertyId, params }) {
    try {
      const { data } = await ApiService.get(`properties/${propertyId}/media`, {
        params,
      });
      return data.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async fetchAvailabilityDefaultMedia({ commit, dispatch }, propertyId) {
    try {
      const data = await dispatch("fetchPropertyMedia", {
        propertyId,
        params: { page: 1, perPage: 1 },
      });

      commit("setAvailabiltyDefaultMedia", [
        ...data.content.map(({ url }) => url),
      ]);
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async fetchPropertyFacilities({ commit }, propertyId) {
    try {
      commit("setFetchingFacilities", true);
      const { data } = await ApiService.get(
        `properties/${propertyId}/facilities`
      );
      return data;
    } catch (error) {
      throw handleApiError(error);
    } finally {
      commit("setFetchingFacilities", false);
    }
  },
  async getFacilitiesCount(_, params) {
    try {
      const { data } = await ApiService.get("properties/facilities/count", {
        params,
      });
      return data.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async getPropertySettings({ commit }, id) {
    try {
      const { data } = await ApiService.get(`properties/${id}/settings`);
      commit("setSettingsData", data);
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async fetchMinRates(_, payload) {
    try {
      const { data } = await ApiService.post("properties/min-rates", payload);
      return data;
    } catch (error) {
      return {};
    }
  },
  async fetchFromRates(_, payload) {
    try {
      const { data } = await ApiService.post("properties/from-rates", payload);
      return data;
    } catch (error) {
      return {};
    }
  },
  async fetchPropertyDocuments({ commit }, id) {
    try {
      const { data } = await ApiService.get(`properties/${id}/documents`);
      commit("setDocumentsData", data.data);
    } catch (error) {
      throw handleApiError(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
